import { deleteApiRequest } from 'api';

export const deleteMeetingFile = (fileId: number): Promise<unknown> => {
    return deleteApiRequest(`/meeting/files/delete/${fileId}/`);
};
